import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import { SECURITY } from "@/lib/content";

export default function Security() {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-14 pt-10 pb-24">
      <div className="max-w-2xl">
        <div className="overline text-cobalt-500">Security first</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl font-black tracking-tighter">
          Built by a cybersecurity team.
        </h1>
        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
          Arventiq Labs is a cybersecurity and EdTech lab &mdash; security isn't bolted on, it's the foundation.
          Verified logins, encrypted secrets, strict per-tenant isolation, and India-first data residency.
        </p>
        <a href="https://arventiqlabs.com/services.html" target="_blank" rel="noreferrer"
           className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-cobalt-500 hover:underline">
          Explore our security services <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>

      <div className="mt-10 grid sm:grid-cols-2 gap-5">
        {SECURITY.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="glass rounded-2xl p-6">
              <div className="flex items-center gap-2">
                <Icon className="h-4 w-4 text-cobalt-500" />
                <span className="font-medium">{s.label}</span>
              </div>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.detail}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-14 glass-strong rounded-3xl p-10 lg:p-12 text-center">
        <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tighter">
          Have a security question before you sign up?
        </h2>
        <p className="mt-3 text-muted-foreground max-w-xl mx-auto">
          Talk to us directly — we respond within one business day.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link to="/contact"
            className="inline-flex items-center gap-1.5 rounded-full h-11 px-6 font-medium bg-zinc-900 hover:bg-zinc-800 text-white dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100 transition-colors">
            Contact us <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
